import React from 'react';

import CountUp from 'react-countup'

import Img from '../assets/about.png'

import {useInView} from 'react-intersection-observer'

import {motion} from 'framer-motion' 

import {fadeIn} from '../variants' 

const About = () => {
  const [ref, InView] = useInView({
    threshold: 0.5,
  });
  return ( 
  <section className='section' id='about' ref={ref}>
      <div className="container mx-auto">
        <div className='flex flex-col gapy-y-10 lg:flex-row lg:items-center lg:gap-x-20 lg:gap-y-0 h-screen'>
          {/* img */}
          <motion.div 
          variants={fadeIn('right', 0.3)}
          initial="hidden"
          whileInView={"show"}
          viewport={{once: false, amount: 0.3}}
          className=''>
             <img src={Img} alt='' className='flex-1 h-[640px] bg-top' />
          </motion.div>
          {/* text */}
          <motion.div 
          className='flex-1'
          variants={fadeIn('left', 0.5)}
          initial="hidden"
          whileInView={"show"}
          viewport={{once: false, amount: 0.3}}
          >
            <h2 className='h2 text-accent'>About me</h2>
            <h3 className='h3 mb-3'>I'am a Front-end Developer with 12+ Months of experience.</h3>
            <p className='mb-6'>
              I love to design/develop beautiful Websites and 
              I am always looking for ways to get even better everyday!

            </p>
            {/* stats */} 
            <div className='flex gap-x-6 lg:gap-x-10 mb-12'>
              <div>
                <div className='text-[40px] font-tertiary text-gradient mb-2'>
                  {
                    InView ?
                    <CountUp start={0} end={18} duration={3} /> : null}
                </div>
                <div className='font-primary text-sm tracking-[2px]'>
                  Months of <br/>
                  Experience 
                </div>
              </div>
              <div>
                <div className='text-[40px] font-tertiary text-gradient mb-2'>
                  {
                    InView ?
                    <CountUp start={0} end={40} duration={3} /> : null}
                </div>
                <div className='font-primary text-sm tracking-[2px]'>
                  Projects <br/>
                  completed
                </div>
              </div>
            </div>
          </motion.div>
        </div>   
      </div> 
    </section>
  );
};

export default About;
